export const qualificationStep = {
  id: 'qualification',

  buildPrompt(ctx, prior) {
    const { prompts, computed } = ctx;
    const parts = [];
    if (prompts.qualificationPrompt) parts.push(`QUALIFIKATION:\n${prompts.qualificationPrompt}`);

    const defaultScores = (prior.scoring?.processedScores || []).filter((s) =>
      String(s.questionId).startsWith('default_')
    );

    const redactName = computed.redactName || ((t) => t);
    const summaryLines = defaultScores
      .map((s) => {
        const q = computed.questionById.get(String(s.questionId));
        const qText = (q?.text || '').replace(/<[^>]*>/g, '').trim() || s.questionId;
        const answer = ctx.submission.answers[s.questionId];
        // Redact per fragment, never the whole line — the questionId must
        // reach Gemini verbatim so its verdicts can be matched back.
        return `[${s.questionId}] "${redactName(qText)}" → ${s.score}/${s.maxScore} P, Antwort: ${redactName(JSON.stringify(answer))}`;
      })
      .join('\n');

    parts.push(
      `Schritt 2 — Qualifikationsprüfung (nur formale Pflichtfragen, default_*).

Punktestand aus Schritt 1 für die formalen Fragen:
${summaryLines || '(keine formalen Fragen vorhanden)'}

Entscheide pro formaler Frage:
- questionId
- passed: true wenn die Antwort die formale Mindestanforderung erfüllt, sonst false
- reason: 1 Satz auf Deutsch, Pflichtfeld

Eine separate Gesamtbegründung der Qualifikation ist NICHT nötig — diese wird in Schritt 3 in die Gesamt-Zusammenfassung integriert. Konzentriere Dich hier nur auf die pass/fail-Entscheidung pro Frage.`
    );

    return parts.join('\n\n');
  },

  schema: {
    type: 'OBJECT',
    properties: {
      perDefault: {
        type: 'ARRAY',
        items: {
          type: 'OBJECT',
          properties: {
            questionId: { type: 'STRING' },
            passed: { type: 'BOOLEAN' },
            reason: { type: 'STRING' }
          },
          // Force all keys; Gemini otherwise drops un-required fields at random
          // (e.g. `passed`/`reason`), corrupting the qualification verdict.
          propertyOrdering: ['questionId', 'passed', 'reason'],
          required: ['questionId', 'passed', 'reason']
        }
      }
    },
    required: ['perDefault']
  },

  parse(json) {
    const list = Array.isArray(json?.perDefault) ? json.perDefault : [];
    const perDefaultById = new Map(
      list.filter((x) => x && x.questionId).map((x) => [String(x.questionId), x])
    );
    return { perDefaultById };
  }
};
